module.exports = __webpack_public_path__ + "static/animation-oss-cover-f3d17150cc295790f62ebb454ac2a54b.png";